module.exports = __webpack_public_path__ + "static/media/menu-invites.ea79b63e.svg";